import type { ApplyStatusesShow } from '@/types';
import { LogoutLink } from '../components/LogoutLink';
import { StatusView } from '../components/StatusView';

// app/(public)/26-co/apply/status/page.tsx.
export default function Show({
  leader,
  members,
  modality,
  status,
  viewerRole,
  leaderWillTransfer,
}: ApplyStatusesShow) {
  return (
    <>
      <LogoutLink />
      <StatusView
        leader={leader}
        members={members}
        modality={modality}
        status={status}
        viewerRole={viewerRole}
        leaderWillTransfer={leaderWillTransfer}
      />
    </>
  );
}
